export const SEARCH_STUDENTS = 'SEARCH_STUDENTS';
export const SELECTED_PROFILE = 'SELECTED_PROFILE';
export const SEARCH_ORGANIZATION = 'SEARCH_ORGANIZATION';
export const STUDENT_LOOKUP = 'STUDENT_LOOKUP';
export const SET_INITIAL_GPA = 'SET_INITIAL_GPA';
export const SET_ACTIVATED_GPA = 'SET_ACTIVATED_GPA';



